export const translations = {
  STEP: {
    da: 'Trin',
    en: 'Step',
    fi: 'Vaihe',
    no: 'Trinn',
    sv: 'Steg',
  },
};
